import api from './axios';

export function getUSDQuote() {
  return api.get('/currency/usd').then(r => r.data);
}
